import { css, svg } from 'lit';

// Control Icons with Font Size
// Set the width and height to be 1em, which will be the font-size of its parent element
// See https://css-tricks.com/control-icons-with-font-size/
const iconStyle = css`
  width: 0.9em;
  height: 0.9em;
  vertical-align: middle;
  font-size: inherit;
  margin-bottom: 0.1em;
`;

export const LinkIcon = svg`<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style="${iconStyle}"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.4835 9.0944L13.2087 7.36919C14.3803 6.19761 14.3803 4.29812 13.2087 3.12655L12.868 2.78586C11.6965 1.61429 9.79697 1.61429 8.62539 2.78586L6.45138 4.95988C5.2798 6.13145 5.2798 8.03094 6.45138 9.20252L6.79206 9.5432C7.00515 9.75629 7.24231 9.93062 7.4948 10.0662L8.03363 9.52736C8.12106 9.43993 8.1859 9.33847 8.22816 9.23022C7.97957 9.13619 7.74646 8.9891 7.54631 8.78896L7.20562 8.44827C6.45061 7.69326 6.45061 6.46914 7.20562 5.71412L9.37964 3.54011C10.1347 2.78509 11.3588 2.78509 12.1138 3.5401L12.4545 3.88079C13.2095 4.63581 13.2095 5.85992 12.4545 6.61494L11.3183 7.75111C11.4483 8.18806 11.5034 8.64257 11.4835 9.0944Z"
    fill="#6880FF"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.5099 6.89898L2.78469 8.62419C1.61311 9.79576 1.61311 11.6953 2.78469 12.8668L3.12537 13.2075C4.29695 14.3791 6.19644 14.3791 7.36802 13.2075L9.54203 11.0335C10.7136 9.86193 10.7136 7.96243 9.54203 6.79086L9.20135 6.45017C8.98826 6.23709 8.75109 6.06276 8.49861 5.92718L7.95978 6.46601C7.87235 6.55344 7.80751 6.65491 7.76525 6.76315C8.01384 6.85719 8.24695 7.00427 8.4471 7.20442L8.78779 7.54511C9.5428 8.30012 9.5428 9.52424 8.78779 10.2793L6.61377 12.4533C5.85875 13.2083 4.63463 13.2083 3.87962 12.4533L3.53893 12.1126C2.78392 11.3576 2.78392 10.1335 3.53893 9.37844L4.6751 8.24227C4.54508 7.80531 4.49002 7.35081 4.5099 6.89898Z"
    fill="#6880FF"
  />
</svg>`;
